import { useState } from "react";
import { ArrowUp, Square } from "lucide-react";

export const ChatInput = ({ onSend, onStop, isStreaming }) => {
  const [value, setValue] = useState("");
  const canSend = value.trim().length > 0 && !isStreaming;

  const submit = (e) => {
    e.preventDefault();
    if (!canSend) return;
    onSend(value.trim());
    setValue("");
  };

  return (
    <form onSubmit={submit} className="sticky bottom-0 z-30 px-4 sm:px-6 py-4 bg-[#07080C]/90 backdrop-blur-xl border-t border-[#1E2333]">
      <div className="max-w-3xl mx-auto flex items-end gap-3">
        <textarea
          data-testid="chat-message-input"
          className="field"
          rows={1}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={isStreaming ? "Your other self is replying… stop to interrupt" : "Ask your other self anything…"}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) submit(e);
          }}
        />
        {isStreaming ? (
          <button type="button" data-testid="stop-reply-button" className="send-btn stop-btn" onClick={onStop} aria-label="Stop reply">
            <Square size={14} fill="currentColor" />
          </button>
        ) : (
          <button type="submit" data-testid="send-message-button" className="send-btn" disabled={!canSend} aria-label="Send message">
            <ArrowUp size={18} />
          </button>
        )}
      </div>
      <p className="max-w-3xl mx-auto mt-2 font-mono text-[11px] text-[#64748b] tracking-wide">
        Enter to send · Shift+Enter for a new line · nothing is saved
      </p>
    </form>
  );
};
